import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import { PRICING_CODE_METHOD } from 'models/validation';

const PricingCode = ({ parkingPass }) => {
  const { requiredMethods } = parkingPass.validation;
  let code;
  if (requiredMethods.get(PRICING_CODE_METHOD)) {
    code = parkingPass.pricingCode;
  } else {
    code = <FormattedMessage id="parking-pass.regular-purchase" defaultMessage="Regular Purchase" />;
  }

  return (
    <p className="pricing-code align-center text-size-12">
      <FormattedMessage id="parking-pass.pricing-code-label" defaultMessage="For Attendant" /> {code}
    </p>
  );
};

PricingCode.propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
};

export default PricingCode;
